import React from 'react';
import propsStyles from '../SurveyEditorProperties.module.css';
import Checkbox from 'components/Checkbox';
import { useSelector } from 'react-redux';
import { selectUiLanguage } from 'app/preferencesSlice';


import { surveyEditorTexts } from 'utils/appTexts';

const generalTexts = surveyEditorTexts.properties.pageSettings;
const texts = generalTexts.settingsModules.ending;

export default function EndingSettingsModule({settings, updateSettings}) {

    const lang = useSelector( selectUiLanguage );


    if( !settings ) return null;
    
    const generalSettings = settings.general;
    const { showSubtitle, showConfetti, showCallToAction } = generalSettings;


    return (
        <>
            <Checkbox
                size='s'
                className={ propsStyles.checkbox }
                label={ texts.showEpiloge[ lang ] }
                isChecked={ showSubtitle }
                onChange={ isChecked => updateSettings( {prop: 'showSubtitle', value: isChecked} ) }
            />
            <Checkbox
                size='s'
                className={ propsStyles.checkbox }
                label={ texts.showConfetti[ lang ] }
                isChecked={ showConfetti }
                onChange={ isChecked => updateSettings( {prop: 'showConfetti', value: isChecked} ) }
            />
            <Checkbox
                size='s'
                className={ propsStyles.checkbox }
                label={ texts.callToActionButtn[ lang ] }
                isChecked={ showCallToAction }
                onChange={ isChecked => updateSettings( {prop: 'showCallToAction', value: isChecked} ) }
            />
        </>
    )
}